define('services/myservices/huaweiid.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('huaweiIdService', ['$q', '$filter', 'ngDialog', 'OpenApp', 'auiDialog', 'HuaweiTrade', '$state', 'opearteShaService', 'UserInfo', 'myServicesAddSer', 'OpenOther',
        function ($q, $filter, ngDialog, OpenApp, auiDialog, HuaweiTrade, $state, opearteShaService, UserInfo, myServicesAddSer, OpenOther) {


            function submit(Model) {
                var defer = $q.defer();
                if (!Model.selected || !Model.product || !Model.product.appInfo) {
                    defer.reject();
                } else {
                    myServicesAddSer.updateOauthFingerPrint(Model).then(function () {// 指纹，安全URL
                        myServicesAddSer.updatePackageNameOrWebUrl(Model).then(function () {// 包名，应用访问地址
                            addHuaweiIdService(Model).then(function () {
                                $state.go('rollout.submitSuccess', {
                                    serviceItem: Model.serviceItem,
                                    product: Model.product
                                }, {reload: true});
                            }).catch(function () {
                                defer.reject();
                            });
                        }).catch(function () {
                            defer.reject();
                        });
                    }).catch(function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            }

            //添加服务
            function addHuaweiIdService(Model) {
                var defer = $q.defer();
                var appInfo = Model.product.appInfo;
                var serviceAttrs = getParam(Model);
                var params = {
                    request: {
                        prodID: AUI.BaseJSUtil.existy(appInfo.prodID) ? appInfo.prodID : appInfo.appID,
                        prodType: appInfo.prodType,
                        serviceItem: 32,
                        bundleId: Model.selected.bundleId,
                        testBundleId: Model.selected.testBundleId,
                        serviceAttrs: angular.toJson(serviceAttrs)//接入方式
                    }
                };

                if ((Model.product.serviceSingle && Model.product.serviceSingle.srvSerialNo) || Model.product.isUpdate) {

                    OpenApp.updateService(params).then(function (data) {
                        if (data && data.srvSerialNo) {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    }).catch(function (data) {
                        defer.reject();
                    });
                } else {

                    OpenApp.addService(params).then(function (data) {
                        if (data && data.srvSerialNo) {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    }).catch(function (data) {
                        defer.reject();
                    });


                }
                return defer.promise;
            }

            //获取接入方式参数
            function getParam(Model) {
                var appInfo = Model.product.appInfo;
                var serviceAttrs = {};
                var accessMode = [];
                if (appInfo.prodType == 1 || appInfo.prodType == 8 || appInfo.prodType == 21 || appInfo.prodType == 22 || appInfo.prodType == 27 || appInfo.prodType == 28 || appInfo.prodType == 42 || (appInfo.prodType == 19 && appInfo.freeInstallType == 1)) {
                    for (var i = 0; i < Model.accessModeType.length; i++) {
                        if (Model.accessModeType[i].flag) {
                            accessMode.push(Model.accessModeType[i].value);
                        }
                    }
                } else if (appInfo.prodType == 19 && appInfo.freeInstallType == 2) {
                    accessMode.push(Model.accessModeType[1].value);
                } else if (appInfo.prodType == 2 || appInfo.prodType == 23) {
                    accessMode.push(Model.accessModeType[0].value);
                }
                serviceAttrs.accessMode = angular.copy(accessMode);

                return serviceAttrs;
            }

            //重置多选按钮
            function resetAccessMode(Model) {
                if (Model.selected.prodType && Model.selected.prodType === '22') {
                    Model.accessModeType = [
                        {value: 1, name: 'SDK接入', flag: true}
                    ];
                } else {
                    Model.accessModeType = [
                        {value: 1, name: 'SDK接入', flag: true},
                        {value: 2, name: 'JS-SDK接入', flag: false}
                    ];
                }

            }


            return {
                submit: submit,
                resetAccessMode: resetAccessMode,
            }

        }]);
});


